import Slider, { SliderProps } from '@mui/material/Slider'

interface Props extends SliderProps {
    labels?: (number: number) => number | string | JSX.Element
    cleanLabel?: boolean
    className?: string
}

const CustomSlider = ({ className, labels, cleanLabel = false, ...restOfProps }: Props) => (
    <Slider
        className={`${className}`}
        slotProps={{
            valueLabel: {
                className: cleanLabel
                    ? 'bg-transparent text-primary font-normal bottom-[4px]'
                    : 'bg-primary bottom-[4px]',
            },
        }}
        sx={{
            height: 4,
            '& .MuiSlider-thumb': {
                width: 12,
                height: 12,
            },
            '& .MuiSlider-track': {
                height: 4,
            },
            '& .MuiSlider-rail': {
                height: 4,
            },
            '@media (max-width: 640px)': {
                padding: 0,
                '& .MuiSlider-thumb': {
                    width: 8,
                    height: 8,
                },
                '& .MuiSlider-track': {
                    height: 2,
                },
                '& .MuiSlider-rail': {
                    height: 2,
                },
            },
        }}
        valueLabelFormat={labels}
        {...restOfProps}
    />
)

export default CustomSlider
